let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4NlKx")).then(() => parcelRequire('1chQi'));